/* eslint-disable react/jsx-key */
import React, { useContext, useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import {
  modifierCol,
  modifiedDateCol,
  // utilityHeader,
} from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import {
  getUtilityOperatorInfo,
  postUtilityOperatorInfo,
  deleteUtilityOperatorInfo,
  getAuthorization,
  getCredentials,
} from 'api/pgads.js'
import {
  getClientInfo,
  getCompanyNameMap,
  getUtilityNameMap,
} from 'core/selectors'
import CommonScreen from './CommonScreen'
import { Select, Input, Button, Upload, message, Icon } from 'antd'
import R from 'ramda'
import styled from 'styled-components'
import { STORE_UTILITY } from 'core/action-names'
import { JcTmpErrorContext } from 'context'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import { NE_NEW_ENGLAND } from 'client'

const TableTD = styled.td`
  text-align: end;
`

const headers = [
  strCol({
    ident: 'utility',
    display: 'Utility',
    width: 100,
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'companyId',
    display: 'Company',
    width: 450,
  }),
  strCol({
    ident: 'utilityName',
    display: 'Utility Name',
    width: 450,
    isRequired: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getUtilityOperatorInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postUtilityOperatorInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteUtilityOperatorInfo(apiTargetInfo)(data)

const title = 'Utility/Operator'

const mapVal = R.compose(
  R.map(([key, text]) => ({ key, text, value: key })),
  R.sortBy(([, text]) => text.toLowerCase()),
  R.toPairs
)

const UtilityOperator = props => {
  const [insertEvent, setInsertEvent] = useState(false)
  const reloadUtilityNameMap = data => {
    props.saveUtility(data)
  }
  const { setTmpError } = useContext(JcTmpErrorContext)

  // const sortOnData = data => {
  //   // const comp = R.comparator((a, b) =>
  //   //   props.companyNameMap[a.companyId] <= props.companyNameMap[b.companyId] ? 1 : -1
  //   // )
  //   const sort = R.sortWith([
  //     R.ascend(R.prop('companyId')),
  //     R.ascend(R.prop('utilityName')),
  //   ])(data)
  //   return sort
  // }

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Utility Id:</TableTD>
            <td style={{ minWidth: '150px' }}>
              <Input
                key="utility"
                value={insertData.utility}
                placeholder="Utility"
                name="utility"
                onChange={e =>
                  setInsertData({ ...insertData, utility: e.target.value })
                }
                maxLength={3}
              />
            </td>
            <TableTD>Company :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <Select
                className="company"
                style={{ minWidth: '100%' }}
                placeholder="Company"
                onChange={value =>
                  setInsertData({ ...insertData, companyId: value })
                }
                showSearch
              >
                {mapVal(props.companyNameMap).map(m => (
                  <Select.Option value={m.value}>{m.text}</Select.Option>
                ))}
              </Select>
            </td>
            <TableTD>Utility Name :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <Input
                key="utilityName"
                value={insertData.utilityName}
                placeholder="Utility Name"
                name="utilityName"
                onChange={e =>
                  setInsertData({ ...insertData, utilityName: e.target.value })
                }
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  const headerWithFormatter = headers.map(header =>
    header.ident === 'companyId'
      ? {
          ...header,
          ...toSelectionColProps(props.companyNameMap),
          dataFormatter: ({ value }) => props.companyNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            props.companyNameMap[rowData.companyId] || rowData.companyId,
        }
      : // : header.ident === 'utility'
        // ? {
        //     ...header,
        //     sortIndexGetter: ({ rowData }) => rowData.utilityName,
        //   }
        header
  )
  const { apiTargetInfo } = props
  const fileProps = {
    name: 'file',
    action: `${apiTargetInfo.baseUrl}/ne-import/utility`,
    method: 'POST',
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  }
  const extraCriteriaAfterButton = ({ onRetrieve }) => {
    if (props.CLIENT === NE_NEW_ENGLAND)
      return (
        <Upload
          {...fileProps}
          onChange={data => {
            if (data.file.status === 'done') {
              // setImportResponse(data.file.response)
              const errors = data.file.response
              if (errors.length > 0) setTmpError(errors)
              if (!isErrorContains(errors)) {
                message.success('File imported successfully')
                onRetrieve()
              }
            }
          }}
          multiple={false}
          showUploadList={false}
        >
          <Button style={{ marginLeft: '5px' }}>
            <Icon type="upload" /> Import
          </Button>
        </Upload>
      )
    else return <div />
  }

  return (
    <CommonScreen
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      title={title}
      header={headerWithFormatter}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.utility}
      autoRetrieve
      widthOffset={150}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      onRetrieveData={reloadUtilityNameMap}
      sortEnabled
      initialSortOptions={[
        {
          ident: 'companyId',
          display: 'Company',
          sortOrder: 'asc',
        },
      ]}
      sortOptions={[
        {
          ident: 'companyId',
          display: 'Company',
          sortOrder: 'asc',
        },
        {
          ident: 'utilityName',
          display: 'Utility Name',
          sortOrder: 'asc',
        },
      ]}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  companyNameMap: getCompanyNameMap(state),
  utilityNameMap: getUtilityNameMap(state),
  CLIENT: getClientInfo(state),
})
const mapDispatchToMap = dispatch => ({
  saveUtility: utilities =>
    dispatch({ type: STORE_UTILITY, payload: utilities }),
})

export default connect(mapStateToProps, mapDispatchToMap)(UtilityOperator)
